import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n/I18nProvider";
import { toast } from "sonner";
import AdminStats from "../components/admin/AdminStats";
import AdminListings from "../components/admin/AdminListings";
import AdminBookings from "../components/admin/AdminBookings";
import AdminUsers from "../components/admin/AdminUsers";
import AdminReports from "../components/admin/AdminReports";
import AdminRatings from "../components/admin/AdminRatings";
import AdminOrganizations from "../components/admin/AdminOrganizations";
import AdminAuditLog from "../components/admin/AdminAuditLog";
import AdminI18n from "../components/admin/AdminI18n";

const TABS = ["stats", "listings", "bookings", "users", "reports", "ratings", "orgs", "audit", "i18n"];

export default function Admin() {
  const { user, loading } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [tab, setTab] = useState("stats");

  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) {
      toast.error(t("admin.notAllowed"));
      navigate("/");
    }
  }, [loading, user, navigate, t]);

  if (loading || !user) {
    return <Layout><div className="max-w-[1440px] mx-auto p-10 label-tech">{t("detail.loading")}</div></Layout>;
  }
  if (user.role !== "admin") return null;

  return (
    <Layout>
      <div className="max-w-[1440px] mx-auto px-6 pt-10">
        <div className="label-tech">[ {t("admin.title")} ]</div>
        <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tighter mt-2">{t("admin.title")}</h1>

        <div className="mt-8 flex gap-px bg-[var(--ink-200)] border border-[var(--ink-200)] flex-wrap">
          {TABS.map((k) => (
            <button
              key={k}
              onClick={() => setTab(k)}
              className={`px-5 py-3 text-sm font-mono-tech uppercase tracking-[0.1em] ${tab === k ? "bg-[var(--ink)] text-[var(--bone)]" : "bg-[var(--surface)]"}`}
              data-testid={`admin-tab-${k}`}
            >
              {t(`admin.tab.${k}`)}
            </button>
          ))}
        </div>

        <div className="mt-px border border-[var(--ink-200)] bg-[var(--surface)] p-6">
          {tab === "stats" && <AdminStats api={api} t={t} />}
          {tab === "listings" && <AdminListings api={api} t={t} />}
          {tab === "bookings" && <AdminBookings api={api} t={t} />}
          {tab === "users" && <AdminUsers api={api} t={t} />}
          {tab === "reports" && <AdminReports api={api} t={t} />}
          {tab === "ratings" && <AdminRatings api={api} t={t} />}
          {tab === "orgs" && <AdminOrganizations api={api} t={t} />}
          {tab === "audit" && <AdminAuditLog api={api} t={t} />}
          {tab === "i18n" && <AdminI18n api={api} t={t} />}
        </div>
      </div>
    </Layout>
  );
}
